import { Handle, Position } from "reactflow";
import { CustomNodeContainer, StyledNodeLabel } from "./styled";
import { useEffect, useMemo, useState } from "react";
import { logicalTypes } from "./utils";

const CustomNode = ({ data }) => {
  const [currentQuestionHeight, setCurrentQuestionHeight] = useState(0)
  const nodeHeight = useMemo(() => {
    const optionLength = data?.questionData?.options?.length || 1
    if (optionLength <= 7) {
      return 100
    }
    return (100 * optionLength) / 7
  }, [data])

  const renderEdge = (optionData) => {
    if (logicalTypes.includes(data?.questionData?.type) && Object.entries(data.options || {}).length) {

      return Object.entries(optionData.options || {}).map(([key, value], index) => {
        const optionsLength = Object.entries(optionData.options || {}).length;
        const topPosition = optionsLength === 1
          ? '50%'
          : ((nodeHeight / (optionsLength + 1) * (index + 1)) + 10);

        return (
          <>
            <Handle
              key={key}
              type="source"
              position={Position.Right}
              style={{
                backgroundColor: "#555",
                top: topPosition
              }}
              id={key}
              isConnectable={true}
            />
          </>
        );
      })
    } else {
      return <Handle
        type="source"
        position="right"
        style={{ backgroundColor: "#555" }}
      />
    }
  }

  useEffect(() => {
    const element = document.getElementsByClassName("node-label")?.[data?.index]
    setCurrentQuestionHeight(element?.offsetHeight)
  }, [])

  return (
    <CustomNodeContainer style={{
      height: nodeHeight
    }}>
      <Handle
        type="target"
        position="left"
        style={{ backgroundColor: "#555" }}
      />
      <div style={{
        height: nodeHeight, overflow: 'hidden', textOverflow: 'ellipsis', alignItems: 'center', display: currentQuestionHeight > 50 ? 'block' : 'flex'
      }}>
        <StyledNodeLabel className="node-label">{data.label}</StyledNodeLabel>
      </div>
      {renderEdge(data)}

      {/* <Handle
        type="source"
        position={Position.Right}
        style={{ backgroundColor: "#555", top: 20 }}
        id="b"
        isConnectable={true}
      />
      <Handle
        type="source"
        position={Position.Right}
        style={{ backgroundColor: "#555", top: 40 }}
        id="c"
        isConnectable={true}
      /> */}
    </CustomNodeContainer >
  );
};

export default CustomNode;
